import {
  PlanType,
  StripeProductLookupKeys,
} from '@showbie-socrative/socrative-utils';

import axios from '../localAxios';
import { subscriptionPlansUrl } from './salesUrls';

export type PricingPlanData = {
  hasRecentPurchase: boolean;
  offerShowbieCompletePrice: boolean;
} & { [key in PlanType]?: PricingPlan };

export enum BillingPeriod {
  Monthly = 'monthly',
  Yearly = 'yearly',
}

export type BillingData = {
  lookupKey: StripeProductLookupKeys;
  stripePriceid: string;
  tiers: Array<PricingTier>;
};

export type PricingPlan = {
  name: string;
  trialDays: number;
} & { [key in BillingPeriod]: BillingData };

export type PricingTier = { priceCents: number; upTo: number };

export async function getPricingPlans() {
  const url = subscriptionPlansUrl();
  const { data } = await axios.get<PricingPlanData>(url.href);

  return data;
}
